import { authService } from '../services/auth-service'
import {messages} from "../helpers/messages";

export const authActions = {
    login,
    logout,
    workSession,
    checkSession: authService.checkSession,
    checkWorkSession: authService.checkWorkSession
}


async function login(login, password) {
    const data = {
        username: login,
        password,
        grant_type: 'password'
    }
    try {
        await authService.getToken(data)
    } catch (e) {
        if (e?.response?.data?.error_description === 'User with current credentials already exists it system') {
            return messages[40]
        } else if (e?.response?.data?.error_description === 'User is disabled') {
            return messages[50]
        } else if (e?.response?.data?.error_description === 'Expired attorney end date') {
            return messages[60]
            }
        else return  messages[30]

    }
    return 'success'
}

async function logout() {
    try {
        await authService.logout()
    } catch (e) {
        return false
    }
    return true
}

async function workSession(department) {
    try {
        await authService.workSession(department)
    } catch (e) {
        return false
    }
    return true
}